/**
 * Saved delivery addresses on users/{uid} as saved_address_1, saved_address_2, …
 * Shared by customer Cart and Admin place-on-behalf.
 */

/**
 * Next free field name on a user profile (gaps allowed; never overwrite).
 * @param {object} userData
 * @returns {string} e.g. saved_address_1
 */
export function nextSavedAddressFieldName(userData = {}) {
    let idx = 1;
    while (userData[`saved_address_${idx}`]) idx += 1;
    return `saved_address_${idx}`;
}

/**
 * Persistable address fields only (drops UI flags like saveAddress).
 * @param {object} address
 */
export function buildSavedAddressPayload(address = {}) {
    return {
        addressLine3: address.addressLine3 ?? '',
        city: address.city ?? '',
        companyName: address.companyName ?? address.company ?? '',
        email: address.email ?? '',
        firstName: address.firstName ?? '',
        lastName: address.lastName ?? '',
        line1: address.line1 ?? '',
        line2: address.line2 ?? '',
        phone: address.phone ?? '',
        postCode: address.postCode ?? address.postalCode ?? '',
    };
}

/**
 * Resolve Firestore users/{uid} from Auth user or admin customer row.
 * @param {{ uid?: string, id?: string } | null} user
 */
export function resolveUserDocIdForSavedAddress(user) {
    if (!user || typeof user !== 'object') return '';
    return String(user.uid || user.id || '').trim();
}
